import React from "react";
import {withRouter} from "react-router-dom";
import "./GoBack.scss";

class GoBack extends React.PureComponent {
  goBack = ()=>{
    this.props.history.goBack();
  }
  render() {
    return (
      <div className="go_back" onClick={this.props.goBack || this.goBack}>
        <img src="/assets/images/overlay-back.svg" alt="" />
      </div>
    );
  }
}

export default withRouter(GoBack);
